import isSameDay from "date-fns/isSameDay";

import { getOffsetDate } from "fe-shared/src/helpers/dates";

// DatePicker `isNoOffset` encodes a date-only pick as local-midnight shifted
// to read as midnight UTC (see fe-shared DatePicker.getExternalDate). Reverse
// it before comparing/formatting, or the calendar day shifts west of UTC.
export const getActualTransactionDate = (dateString?: string | null) => {
  if (!dateString) {
    return null;
  }
  const time = dateString.substr(11, 8);
  const isNoOffset = time === "00:00:00";

  return isNoOffset ? getOffsetDate(new Date(dateString))! : new Date(dateString);
};

export const hasDistinctTransactionDate = (
  actualTransactionDate?: string,
  submittedDate?: string,
  completedDate?: string
) =>
  !completedDate &&
  !!actualTransactionDate &&
  !!submittedDate &&
  !isSameDay(getActualTransactionDate(actualTransactionDate)!, new Date(submittedDate));
